import React from 'react';

const CaretDownBoldIcon = ({ size = 12, ...props }) => (
  <svg
    width={Math.round(size * 1.5)}
    height={size}
    viewBox='0 0 18 12'
    fill='currentColor'
    {...props}>
    <path d='M7.02638 11.0557L0 2.36575L2.35707 0.457142L7.48132 6.80087L15.7833 0L17.6811 2.36572L7.02638 11.0557Z' />
  </svg>
);

export default CaretDownBoldIcon;
